import { useLocation } from "react-router-dom";

import { path as HomePath } from "v2/pages/home/HomeRoute";
import { BillingPath } from "v2/pages/billing/BillingPath";

import { useActiveSubscription } from "routes/data-routes/billing-data/active-subscription";
import { isLegacyAnnualPlan } from "utils/planUtils";


export function useDarkModeForNewDesign() {
  const location = useLocation();
  const { activeSubscription } = useActiveSubscription();

  return location.pathname.startsWith(HomePath)
    || (!isLegacyAnnualPlan(activeSubscription?.planSlug) && location.pathname.startsWith(BillingPath));
}
